// extracted by mini-css-extract-plugin
export default {"fs":"_631c65a563 _8dff4d6613"};